import axios, { getData } from 'lib/axios'

export const getAllParticipants = (appraisalId, page, data) => {
  return axios
    .post(`/admin/performance/${appraisalId}/participants?page=${page}`, data)
    .then(getData)
}
export const getAllParticipantData = async (appraisalId) => {
  const res = await axios.get(`admin/performance/${appraisalId}/download`, { responseType: 'blob' })
  return res
}

export const getEvalParticipants = (evaluationId, page, data) => {
  return axios.post(`/admin/performance/all/${evaluationId}?page=${page}`, data).then(getData)
}

export const getTeamParticipants = (managerId, appraisalId, page, data) => {
  return axios
    .post(`/performance/team/${managerId}/${appraisalId}?page=${page}`, data)
    .then(getData)
}

export const removeParticipant = ({ evaluation_id, user_id }) => {
  return axios.delete(`/admin/${evaluation_id}/submission/${user_id}`).then(getData)
}

export const removeParticipantinEvaluation = ({ appraisalId, user_id }) => {
  return axios.delete(`admin/${appraisalId}/submission-appraisal/${user_id}`).then(getData)
}
